import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {UserProfileComponent} from './user-profile/user-profile.component';
import { UserFormResolverService } from './services/user-form-resolver.service';
import {NotificationsComponent} from './notifications/notifications.component';

export const profileRoutes: Routes = [
    {path: '', children: [
        {path: '', redirectTo: 'edit', pathMatch: 'full'},
        {path: 'notifications',
            component: NotificationsComponent,
            data: {
                title: 'Уведомления'
            }
        },
        {path: 'edit',
            component: UserProfileComponent,
            data: {title: 'Редактирование профиля пользователя'},
            resolve: {
                formValues: UserFormResolverService
            }
        }
    ]}
];

@NgModule({
    imports: [
        RouterModule.forChild(profileRoutes)
    ],
    exports: [
        RouterModule
    ],
    declarations: [],
    providers: [],
})
export class ProfileRoutingModule {}
